import { useEffect } from "react";
import Lenis from "lenis";

/**
 * Global smooth momentum scroller. Wraps the whole app so scroll-triggered
 * animations, sticky elements, and Framer Motion useScroll behave against a
 * physically eased scroll position instead of the native step scroll.
 */
export default function SmoothScroll() {
  useEffect(() => {
    // Respect users who prefer reduced motion
    if (typeof window !== "undefined" &&
        window.matchMedia?.("(prefers-reduced-motion: reduce)").matches) {
      return;
    }

    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
      wheelMultiplier: 1,
      touchMultiplier: 1.4,
    });

    // Intercept anchor clicks so #hash navigation is eased too.
    const onAnchorClick = (e) => {
      const a = e.target?.closest?.("a[href^='#']");
      if (!a) return;
      const id = a.getAttribute("href").slice(1);
      if (!id) return;
      const el = document.getElementById(id);
      if (!el) return;
      e.preventDefault();
      lenis.scrollTo(el, { offset: -64, duration: 1.2 });
    };
    document.addEventListener("click", onAnchorClick);

    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);

    return () => {
      cancelAnimationFrame(raf);
      document.removeEventListener("click", onAnchorClick);
      lenis.destroy();
    };
  }, []);

  return null;
}
